import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
const TOKEN_KEY = "babul_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);

export const authHeader = () => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export const apiLogin = async (email, password) => {
  const { data } = await axios.post(`${API}/auth/login`, { email, password });
  return data;
};

export const apiMe = async () => {
  const { data } = await axios.get(`${API}/auth/me`, { headers: authHeader() });
  return data;
};

export const apiStats = async () => {
  const { data } = await axios.get(`${API}/admin/inquiries/stats`, { headers: authHeader() });
  return data;
};

export const apiListInquiries = async (status) => {
  const params = status && status !== "all" ? { status } : {};
  const { data } = await axios.get(`${API}/admin/inquiries`, { headers: authHeader(), params });
  return data;
};

export const apiUpdateStatus = async (id, status) => {
  const { data } = await axios.patch(
    `${API}/admin/inquiries/${id}`,
    { status },
    { headers: authHeader() }
  );
  return data;
};

export const apiDeleteInquiry = async (id) => {
  const { data } = await axios.delete(`${API}/admin/inquiries/${id}`, { headers: authHeader() });
  return data;
};

export const exportCsvUrl = () => `${API}/admin/inquiries/export.csv`;

export function formatApiError(err) {
  const d = err?.response?.data?.detail;
  if (!d) return err?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return String(d);
}
